import React, {Component} from 'react';
import axios from "axios";
import {BubbleLoader} from "react-css-loaders";
import ProductTile from "../components/ProductTile";
import {Button, Col, Row} from "react-bootstrap";
import ProductRow from "../components/ProductRow";
import * as PT from "../global/PortalTools";
import {Session} from "../global/PortalTools";
import Breadcrumbs from "../B2B/Breadcrumbs";
import {ST} from "../global/SystemText";
import {Link} from "react-router-dom";

export default class ServiceProductDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            loaded: false,
            data: {},
            limit: "",
            sort: "",
            page: 1,
            paginationLimit: 5,
        };

    }

    componentDidMount() {
        let defaultSort = "service_project_date DESC";
        let defaultPage = 1;
        let defaultLimit = 24;
        this.setState({
            limit: defaultLimit,
            sort: defaultSort,
            page: defaultPage,
        }, this.getCustomerProduct());


    }

    componentDidUpdate(nextProps, nextState, nextContext) {
        if (!this.state.loaded) {
            this.getCustomerProduct();
        }
    }

    getCustomerProduct() {
        console.log(this.state.id);
        axios.get(Session.getItem("endpoint") + 'PortalServlet', {
            params: {
                idMandant: Session.idMandant,
                idCompany: Session.getItem("idCompany"),
                idContact: Session.getItem("idContact"),
                idLanguage: Session.getItem("idLanguage"),
                idCurrency: Session.getItem("idCurrency"),
                priceLevel: Session.getItem("priceLevel"),
                limit: this.state.limit,
                sort: this.state.sort,
                page: this.state.page,
                id: this.state.id,
                action: "GET_PORTAL_SERVICE_PRODUCT"
            }
        })
            .then((response) => {
                console.log(response.data);
                this.setState({
                    data: response.data,
                    loaded: true
                });
            })
            .catch((error) => {
                PT.handleError(error, this.props.history);
            });
    }

    changeLimit(event) {
        this.setState({limit: event.target.value, loaded: false})
    }

    changeSort(event) {
        this.setState({sort: event.target.value, loaded: false})
    }



    render() {

        let pages = Math.ceil(this.state.data.countOrders / this.state.limit);
        let paginations = [];
        let {page, paginationLimit} = this.state;
        for (let i = 1; i <= pages; i++) {
            if (i === 1 || i === pages) {
                paginations.push(<li key={i}>
                    <Button onClick={() => {
                        this.setState({page: i, loaded: false})
                    }} size={"sm"} style={this.state.page === i ? {
                        background: window.portalSettings.portal_pcolor,
                        color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                    } : {}}>{i}</Button>
                </li>);
                continue;
            }
            if (i < (page - paginationLimit)) {
                continue;
            }
            if (i > (page + paginationLimit)) {
                continue;
            }
            if (i === (page - paginationLimit) || i === (page + paginationLimit)) {
                paginations.push(<li key={i}>
                    <Button disabled size={"sm"} style={this.state.page === i ? {
                        background: window.portalSettings.portal_pcolor,
                        color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                    } : {}}>...</Button>
                </li>);
                continue;
            }

            paginations.push(<li key={i}>
                <Button onClick={() => {
                    this.setState({page: i, loaded: false})
                }} size={"sm"} style={this.state.page === i ? {
                    background: window.portalSettings.portal_pcolor,
                    color: PT.getColorBrightness(window.portalSettings.portal_pcolor) < 135 ? "white" : "#333"
                } : {}}>{i}</Button>
            </li>);
        }
        if (this.state.loaded) {
            return (
                <div className="panel border-top-xlg" style={{borderColor: window.portalSettings.portal_pcolor}}>
                    <Breadcrumbs type={"service"} active={this.state.data.serialNumber}/>
                    <div className="panel-heading no-padding-bottom">
                        <h3 className="panel-title">{this.state.data.serialNumber}</h3>
                    </div>
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-lg-6 ">
                                <div className={"row"}>
                                    <div className={"col-lg-6"}>
                                        {ST.get("serialNumber", "service")}:
                                    </div>
                                    <div className={"col-lg-6"}>
                                        {this.state.data.serialNumber}
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-6"}>
                                        {ST.get("product_name", "product")}:
                                    </div>
                                    <div className={"col-lg-6"}>
                                        {this.state.data.name}
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-6"}>
                                        {ST.get("date2", "service")}:
                                    </div>
                                    <div className={"col-lg-6"}>
                                        {this.state.data.date}
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-6"}>
                                        {ST.get("warrantyDate", "service")}:
                                    </div>
                                    <div className={"col-lg-6"}>
                                        {this.state.data.warranty}
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-6"}>
                                        {ST.get("description", "service")}:
                                    </div>
                                    <div className={"col-lg-6"}>
                                        {this.state.data.description}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 ">
                                {this.state.data.plans && this.state.data.plans.length > 0 &&<>
                                <h5 style={{marginTop:0}} className={"mt-0"}>{ST.get("servicePlan", "service")}</h5>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                        <tr>
                                            <th className="text-left">{ST.get("date", "service")}</th>
                                            <th className="text-left">{ST.get("interval", "service")}</th>
                                            <th className="text-left">{ST.get("description", "global")}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.plans.map((element, index) => {
                                            return (<tr key={index}>
                                                <td>{element.dateStart} - {element.dateEnd}</td>
                                                <td>{element.interval} {element.interval_type===1?ST.get("intervalType1","service"):ST.get("intervalType2","service")}</td>
                                                <td>{element.description}</td>
                                            </tr>);
                                        })}

                                        </tbody>
                                    </table>
                                </div>
                                </>}
                            </div>
                        </div>
                        <hr/>
                        {this.state.data.orders ? <>
                                <div className="product-toolbox">
                                    <div className="row">
                                        <div className="col-lg-4 ">
                                            <h5>{ST.get("serviceHistory", "service")}</h5>
                                        </div>
                                        <div className="col-lg-8 text-right">
                                            <div className="input-group inline">
                                                <label className="pt-15">{ST.get("show", "global")}:</label>
                                                <select value={Number(this.state.limit)} className="form-control"
                                                        onChange={this.changeLimit.bind(this)}>
                                                    <option value={24}>24</option>
                                                    <option value={48}>48</option>
                                                </select>
                                            </div>
                                            <div className="input-group inline">
                                                <label className="pt-15">{ST.get("order_by", "global")}:</label>
                                                <select className="form-control" value={this.state.sort}
                                                        onChange={this.changeSort.bind(this)}>
                                                    <option
                                                        value={"service_project_date DESC"}>{ST.get("creation_date", "global")}</option>
                                                    <option value={"service_project_number ASC"}>A-Z</option>
                                                    <option value={"service_project_number DESC"}>Z-A</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                        <tr>
                                            <th className="text-left">{ST.get("number", "global")}</th>
                                            <th className="text-left">{ST.get("state", "global")}</th>
                                            <th className="text-left">{ST.get("creation_date", "global")}</th>
                                            <th className="text-left">{ST.get("date", "service")}</th>
                                            <th className="text-left">{ST.get("warranty", "service")}</th>
                                            <th className="text-left">{ST.get("paid", "service")}</th>
                                            <th className="text-left">{ST.get("intrauser", "service")}</th>
                                            <th className="text-left"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.orders.map((element, index) => {
                                            return (<tr key={index}>
                                                <td>{element.number}</td>
                                                <td>{element.state && <span className={"stateBox" + (element.state.percent === 100 ? " document-end-state" : " document-progress-state")}>{element.state.name}</span>}</td>
                                                <td>{element.date}</td>
                                                <td>{element.dateStart} - {element.dateEnd}</td>
                                                <td>{element.warranty?ST.get("yes","global"):ST.get("no","global")}</td>
                                                <td>{element.paid?ST.get("yes","global"):ST.get("no","global")}</td>
                                                <td>{element.intrauser?.name}</td>
                                                <td>
                                                        {element.documents?.map((element, index) => (
                                                            element.isImage?null:
                                                                <div key={index}>
                                                                    <a target="_blank" rel="noopener noreferrer" href={Session.getItem("endpoint") + element.url}>
                                                                        <i className={"oicon24 oicon-" + element.ext}/> {element.name}
                                                                    </a>
                                                                </div>
                                                        ))}

                                                </td>
                                            </tr>);
                                        })}

                                        </tbody>
                                    </table>
                                </div>

                                <div className="text-center content-group-lg pt-20">
                                    <ul className="pagination">
                                        <li className={this.state.page === 1 ? "disabled" : ""}><Button
                                            disabled={this.state.page === 1} onClick={() => {
                                            this.setState({page: (this.state.page - 1), loaded: false})
                                        }} size={"sm"} variant={"light"}><i className="icon-arrow-small-left"/></Button>
                                        </li>
                                        {paginations.map((element, index) => {
                                            return (element);
                                        })}
                                        <li className={this.state.page === pages ? "disabled" : ""}>
                                            <Button disabled={this.state.page === pages} onClick={() => {
                                                this.setState({page: (this.state.page + 1), loaded: false})
                                            }} size={"sm"} variant={"light"}><i
                                                className="icon-arrow-small-right"/></Button></li>
                                    </ul>
                                </div>
                            </> :
                            <div className="">
                                <div className="row">
                                    <div className="col-lg-12 ">
                                        <h5>{ST.get("service_history", "global")}</h5>
                                    </div>
                                </div>
                                <Row>
                                    <Col md={12} style={{padding: "25px"}}>
                                        {ST.get("no_records_found", "global")}
                                    </Col>
                                </Row>
                            </div>}
                    </div>
                </div>
            )

        } else {
            return (<BubbleLoader color={window.portalSettings.portal_pcolor}/>);
        }
    }
}